import React, { Component } from "react";
import { COLORS } from "../pages/theme";
import {
  ErrorOutline,
  DoneOutlined,
  CloseOutlined,
  PlayArrowRounded,
  ReplayRounded,
  PauseRounded,
} from "@material-ui/icons";
import { RESTExecutor, withDomains } from "../lib/domain";

class EngineStatusCard extends Component {
  constructor(props) {
    super(props);

    this.restart_engine = RESTExecutor.post()
      .config({
        label: "restart_engine",
      })
      .connect(props.domains.dashboard);
  }

  render() {
    const { title, status, style, engine } = this.props;

    return (
      <div
        className="default-card"
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          padding: 12,
          margin: 0,
          ...style,
        }}
      >
        {status == null ? (
          <ErrorOutline className="baisc-icon" />
        ) : (
          <React.Fragment>
            <div
              style={{
                width: "100%",
                cursor: "pointer",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <ReplayRounded
                htmlColor="blue"
                onClick={() => {
                  this.restart_engine.execute({
                    engine_name: engine,
                    mode: "restart",
                  });
                }}
              />
              {status ? (
                <PauseRounded
                  htmlColor="red"
                  onClick={() => {
                    this.restart_engine.execute({
                      engine_name: engine,
                      mode: "stop",
                    });
                  }}
                />
              ) : (
                <PlayArrowRounded
                  htmlColor="green"
                  onClick={() => {
                    this.restart_engine.execute({
                      engine_name: engine,
                      mode: "start",
                    });
                  }}
                />
              )}
            </div>
            <span
              className="sub-heading-1"
              style={{
                color: COLORS.secondary,
                textAlign: "center",
              }}
            >
              {title}
            </span>
            <div
              style={{
                marginTop: 12,
                marginBottom: 12,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                height: 38,
                width: 38,
                borderRadius: 19,
                backgroundColor: status
                  ? COLORS.success_secondary
                  : COLORS.danger_secondary,
                color: status ? COLORS.success_primary : COLORS.danger_primary,
              }}
            >
              {status ? <DoneOutlined /> : <CloseOutlined />}
            </div>
            <span className="sub-heading-2">
              {status ? "Working Fine" : "Not Working"}
            </span>
          </React.Fragment>
        )}
      </div>
    );
  }
}

export default withDomains(EngineStatusCard, "dashboard");
